module.exports = __webpack_public_path__ + "static/8-man-e556aa091beb2ea3ef2960068e59c92e.jpg";